import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import "./AddPurchase.css";
import axios from "axios";

const EditTask = () => {
  const { task_id } = useParams();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [customerList, setCustomers] = useState([]);
  const userName = JSON.parse(localStorage.getItem('user_name'));

  const [formData, setFormData] = useState({
    task_id: task_id,
    task_theme: "",
    task_name: "",
    description: "",
    priority: "",
    due_date: "",
    status: "",
    assigned_to: "",
    assigned_by: "",
    assigned_by_name: "",
    created_at: "",
    auto_creation: "0",
    day: "",
        type: "",

  });

  useEffect(() => {
    axios.post(`${API_BASE_URL}user_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });

    axios.post(`${API_BASE_URL}task_detail.php`, { task_id: task_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          const apiData = response.data.body;

          // convert DD-MM-YYYY → YYYY-MM-DD
          const convertToInputDate = (dateStr) => {
            if (!dateStr) return "";
            const [dd, mm, yyyy] = dateStr.split("-");
            return `${yyyy}-${mm}-${dd}`;
          };

          const updatedData = {
            ...apiData,
            due_date: convertToInputDate(apiData.due_date),
            created_at: convertToInputDate(apiData.created_at),
          };

          setFormData(updatedData);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setFormData([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setFormData([]);
      }).finally(() => {
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Updated Task:", formData);
    // TODO: Submit updated task to backend
    axios.post(`${API_BASE_URL}task_detail_edit.php`, formData)
      .then((response) => {
        // console.log("=========",response);
        if (response.data.head.code === 200) {
          // setDepartmentList(response.data.body);
          // setFilteredOrders(response.data.body);
          navigate("/task");
          //  navigate("/tasklist");
          // window.history.back();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setDepartmentList([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setDepartmentList([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });

  };

  return (
    <Container className="my-4">
      <div className="form-header mb-4 d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Edit Task</h4>
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <Form onSubmit={handleSubmit}>
        <Row className="g-3">
          {/* Theme */}
          <Col lg={4} md={12}>
            <Form.Group>
              <Form.Label>Theme</Form.Label>
              <Form.Control
                type="text"
                name="task_theme"
                value={formData.task_theme}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          {/* Title */}
          <Col lg={4} md={12}>
            <Form.Group>
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                name="task_name"
                value={formData.task_name}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          {/* Priority */}
          <Col lg={4} md={12}>
            <Form.Group>
              <Form.Label>Priority</Form.Label>
              <Form.Select
                name="priority"
                value={formData.priority}
                onChange={handleChange}
              >
                <option value="">Select Priority</option>
                <option value="Low">Low</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
                <option value="Critical">Critical</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Description */}
          <Col lg={12}>
            <Form.Group>
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="description"
                value={formData.description}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          {/* Due Date */}
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Due Date</Form.Label>
              <Form.Control
                type="date"
                name="due_date"
                value={formData.due_date}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          {/* Status */}
          {
            userName === formData.assigned_by_name && (
              <Col lg={6} md={12}>
                <Form.Group>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="">Select Status</option>
                    <option value="Assigned">Assigned</option>
                    <option value="Completed">Completed</option>
                    <option value="Rejected">Rejected</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            )
          }


          {/* Assigned To */}
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Assigned To</Form.Label>
              <Form.Select
                name="assigned_to"
                value={formData.assigned_to}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Assignee</option>
                {customerList.map((user) => (
                  <option key={user.user_id} value={user.user_id}>
                    {user.name}
                  </option>
                ))}
                {/* add more users dynamically if needed */}
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Assigned By */}
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Assigned By</Form.Label>
              <Form.Select
                name="assigned_by"
                value={formData.assigned_by}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Assigner</option>
                {customerList.map((user) => (
                  <option key={user.user_id} value={user.user_id}>
                    {user.name}
                  </option>
                ))}
                {/* add more assigners dynamically if needed */}
              </Form.Select>
            </Form.Group>
          </Col>


          {/* Created At */}
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Created At</Form.Label>
              <Form.Control
                // type="datetime-local"
                type="date"
                name="created_at"
                value={formData.created_at}
                disabled
              />
            </Form.Group>
          </Col>
              
         

          <Col lg={6} md={12}>
            <Row>
              {formData.type === "" && (
              <Col md={6} sm={12}>
                <Form.Group className="mt-4">
                  <Form.Check
                    type="checkbox"
                    label="Auto Creation"
                    name="auto_creation"
                    checked={formData.auto_creation === "1"}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        auto_creation: e.target.checked ? "1" : "0",
                      })
                    }
                  />
                </Form.Group>
              </Col>
              )}

              {/* Day Dropdown */}
              {formData.type === "" && (
              <Col md={6} sm={12}>
                <Form.Group>
                  <Form.Label>Day</Form.Label>
                  <Form.Select
                    name="day"
                    value={formData.day}
                    onChange={handleChange}
                  >
                    <option value="">Select Day</option>
                    <option value="Sunday">Sunday</option>
                    <option value="Monday">Monday</option>
                    <option value="Tuesday">Tuesday</option>
                    <option value="Wednesday">Wednesday</option>
                    <option value="Thursday">Thursday</option>
                    <option value="Friday">Friday</option>
                    <option value="Saturday">Saturday</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              )}
            </Row>
          </Col>
        </Row>

        {/* Buttons */}
        <div className="form-actions mt-4 d-flex justify-content-end gap-2">
          <Button type="submit" className="btn-submit">
            Update
          </Button>
          <Button
            type="button"
            className="btn-top"
            onClick={() => navigate(-1)}
          >
            Cancel
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default EditTask;
